/**
 * @generated SignedSource<<6fbdde2bb375cd4bfdb3e1c894c002ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addCollageRulePanel_GridRulesListQuery$variables = Record<PropertyKey, never>;
export type addCollageRulePanel_GridRulesListQuery$data = {
  readonly gridRules: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
};
export type addCollageRulePanel_GridRulesListQuery = {
  response: addCollageRulePanel_GridRulesListQuery$data;
  variables: addCollageRulePanel_GridRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GridRule",
    "kind": "LinkedField",
    "name": "gridRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addCollageRulePanel_GridRulesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addCollageRulePanel_GridRulesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2e6e61bed90332ee6a74a0f411915964",
    "id": null,
    "metadata": {},
    "name": "addCollageRulePanel_GridRulesListQuery",
    "operationKind": "query",
    "text": "query addCollageRulePanel_GridRulesListQuery {\n  gridRules {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d58c822302caaf732de0d4862ec073d";

export default node;
